export default __webpack_public_path__ + "static/Ozleasing-225a2e864574e8ee427e9ea20b96665a.mp4";